export default "/react/logoVarioqub-20a14d3e.png";